import { ArrowLeft } from "lucide-react";

const SECTIONS = [
    {
        title: "1. Wie zijn wij?",
        body: "MeerjarenplanOnline.nl is de aanbieder van de web applicatie voor investeringsscenario's met AI, bedoeld voor verenigings- en stichtingsbesturen, accountants, adviseurs en DGA's. Voor vragen over deze verklaring of over de verwerking van je gegevens kun je contact met ons opnemen via info@club-fin.nl of via het demoformulier op deze website.",
    },
    {
        title: "2. Welke gegevens verzamelen wij?",
        body: "Wanneer je een demo aanvraagt via het formulier op deze pagina, verwerken wij de volgende persoonsgegevens: je naam, je e-mailadres, de naam van je organisatie (bijvoorbeeld je vereniging of stichting) en eventueel een door jou ingevulde opmerking of vraag. Daarnaast verzamelen wij — alleen met jouw toestemming — anonieme gebruiksstatistieken over het bezoek aan deze website.",
    },
    {
        title: "3. Waarvoor gebruiken wij je gegevens?",
        body: "Wij gebruiken je gegevens uitsluitend om contact met je op te nemen naar aanleiding van je demo-aanvraag en om je verder te helpen bij het kennismaken met MeerjarenplanOnline.nl. Wij verkopen je gegevens nooit aan derden en gebruiken ze niet voor andere doeleinden dan hier beschreven.",
    },
    {
        title: "4. Op welke grondslag verwerken wij je gegevens?",
        body: "De verwerking van je gegevens via het demoformulier vindt plaats op grond van jouw toestemming (art. 6 lid 1 sub a AVG) en ons gerechtvaardigd belang om contact met je op te nemen over onze dienstverlening (art. 6 lid 1 sub f AVG). Analytische cookies plaatsen wij alleen na jouw uitdrukkelijke toestemming via de cookiebanner.",
    },
    {
        title: "5. Hoe lang bewaren wij je gegevens?",
        body: "Wij bewaren je gegevens niet langer dan noodzakelijk. Gegevens uit een demo-aanvraag bewaren wij maximaal 12 maanden na het laatste contactmoment, tenzij je eerder om verwijdering vraagt.",
    },
    {
        title: "6. Cookies",
        body: "Deze website gebruikt functionele (noodzakelijke) cookies om de site goed te laten werken. Daarnaast gebruiken wij analytische cookies om inzicht te krijgen in het gebruik van de website, maar alleen als je hiervoor toestemming geeft via de cookiebanner. Je kunt je keuze op elk moment aanpassen door je browsercache te wissen; de banner verschijnt dan opnieuw.",
    },
    {
        title: "7. Met wie delen wij je gegevens?",
        body: "Wij maken gebruik van zorgvuldig geselecteerde hosting- en analysepartijen voor het technisch beheer van deze website. Met deze partijen sluiten wij waar nodig een verwerkersovereenkomst conform de AVG. Verder delen wij je gegevens niet met derden.",
    },
    {
        title: "8. Jouw rechten",
        body: "Op grond van de AVG heb je recht op inzage, correctie, verwijdering, beperking van de verwerking, overdraagbaarheid van je gegevens en het intrekken van eerder gegeven toestemming. Neem hiervoor contact met ons op via info@club-fin.nl. Je hebt bovendien het recht een klacht in te dienen bij de Autoriteit Persoonsgegevens (autoriteitpersoonsgegevens.nl).",
    },
    {
        title: "9. Beveiliging",
        body: "Wij nemen passende technische en organisatorische maatregelen om je gegevens te beveiligen tegen verlies, misbruik en onbevoegde toegang, waaronder versleutelde verbindingen (HTTPS) en beperkte toegang tot opgeslagen gegevens.",
    },
    {
        title: "10. Wijzigingen",
        body: "Wij kunnen deze privacyverklaring van tijd tot tijd aanpassen. De meest actuele versie staat altijd op deze pagina. Deze versie is bijgewerkt op 30 augustus 2026.",
    },
];

const Privacy = () => (
    <div data-testid="privacy-page" className="min-h-screen bg-[#F9FAFB]">
        <header className="bg-[#0A0A0A] noise-overlay">
            <div className="max-w-4xl mx-auto px-6 md:px-12 py-8 flex items-center justify-between">
                <div>
                    <a href="/" data-testid="privacy-logo" aria-label="MeerjarenplanOnline.nl">
                        <img src="/images/logo.png" alt="MeerjarenplanOnline.nl" className="h-7 w-auto" />
                    </a>
                    <p className="text-white/50 text-xs mt-1.5">een service van Club-Fin.nl</p>
                </div>
                <a
                    href="/"
                    data-testid="privacy-back-link"
                    className="inline-flex items-center gap-2 rounded-full border border-white/20 hover:border-white/60 text-white text-sm font-bold px-5 py-2.5 transition-[border-color] duration-300"
                >
                    <ArrowLeft className="w-4 h-4" />
                    Terug naar home
                </a>
            </div>
        </header>

        <main className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
            <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#FF6B00] mb-5">AVG / GDPR</p>
            <h1 className="font-heading text-[#0A0A0A] font-black tracking-tighter text-4xl sm:text-5xl leading-[1.02] mb-6">
                Privacyverklaring
            </h1>
            <p className="text-[#0A0A0A]/60 text-base leading-relaxed mb-14 max-w-2xl">
                MeerjarenplanOnline.nl hecht veel waarde aan de bescherming van persoonsgegevens. In deze
                verklaring leggen wij uit welke gegevens wij verzamelen via deze website, waarom
                wij dat doen en welke rechten je hebt op grond van de Algemene Verordening
                Gegevensbescherming (AVG).
            </p>

            <div className="space-y-0">
                {SECTIONS.map((s, i) => (
                    <section key={s.title} data-testid={`privacy-section-${i}`} className="border-t border-black/10 py-8">
                        <h2 className="font-heading text-[#0A0A0A] font-bold tracking-tight text-xl sm:text-2xl mb-3">
                            {s.title}
                        </h2>
                        <p className="text-[#0A0A0A]/70 text-base leading-relaxed">{s.body}</p>
                    </section>
                ))}
            </div>

            <div className="mt-14 rounded-2xl bg-[#FF6B00] p-8 md:p-10">
                <h2 className="font-heading text-white font-bold tracking-tight text-2xl mb-3">Vragen over je gegevens?</h2>
                <p className="text-white text-base leading-relaxed font-medium">
                    Mail ons op info@club-fin.nl of gebruik het demoformulier op de homepage.
                    Wij reageren binnen één werkdag op vragen over privacy en gegevensbescherming.
                </p>
            </div>
        </main>

        <footer className="border-t border-black/10 py-8">
            <div className="max-w-4xl mx-auto px-6 md:px-12 text-[#0A0A0A]/40 text-xs">
                © 2026 MeerjarenplanOnline.nl. Alle rechten voorbehouden.
            </div>
        </footer>
    </div>
);

export default Privacy;
